import React, { useContext, useEffect } from 'react';
import ArtistReservationManager from '../components/ArtistReservationManager';
// [ARCHIVED] ArtistReservationList moved to Archive folder
// eslint-disable-next-line no-unused-vars
import ArtistReservationAdd from '../components/ArtistReservationAdd';
// eslint-disable-next-line no-unused-vars
import ArtistReservationPending from '../components/ArtistReservationPending';
import './ArtistReservationManagerPage.css';

import { useNavigate } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';
// 추후 예약추가, 예약중리스트 컴포넌트 import 가능

// 사용자 언어 설정을 가져오는 함수
const getUserLanguage = (userInfo) => {
  // 사용자의 preferred_language가 있으면 사용, 없으면 기본값 'ko'
  const lang = userInfo?.preferred_language || 'ko';
  console.log('사용자 언어 설정:', {
    userPreferredLanguage: userInfo?.preferred_language,
    finalLang: lang
  });
  return lang;
};

// 다국어 페이지 제목 - 현재 미사용
// eslint-disable-next-line no-unused-vars
const TITLE = {
  ko: '예약관리페이지',
  en: 'Reservation Management Page',
  fr: 'Page de gestion des réservations',
};

// 다국어 메뉴 아이템 - 현재 미사용
// eslint-disable-next-line no-unused-vars
const MENU_ITEMS = {
  ko: [
    { key: 'main', label: '메인' },
    { key: 'list', label: '예약 목록' },
    { key: 'pending', label: '대기 중인 요청' },
    { key: 'inprogress', label: '진행 중' },
    { key: 'completed', label: '완료됨' },
    { key: 'personal', label: '개인 프로젝트' },
    { key: 'flash', label: '플래시' },
    { key: 'add', label: '예약 추가' },
  ],
  en: [
    { key: 'main', label: 'Main' },
    { key: 'list', label: 'Reservation List' },
    { key: 'pending', label: 'Incoming Requests' },
    { key: 'inprogress', label: 'In Progress' },
    { key: 'completed', label: 'Completed' },
    { key: 'personal', label: 'Personal Projects' },
    { key: 'flash', label: 'Flash' },
    { key: 'add', label: 'Add Reservation' },
  ],
  fr: [
    { key: 'main', label: 'Principal' },
    { key: 'list', label: 'Liste des réservations' },
    { key: 'pending', label: 'Demandes en attente' },
    { key: 'inprogress', label: 'En cours' },
    { key: 'completed', label: 'Terminé' },
    { key: 'personal', label: 'Projets personnels' },
    { key: 'flash', label: 'Flash' },
    { key: 'add', label: 'Ajouter une réservation' },
  ]
};

// 다국어 알림 메시지
const NOTIFICATIONS = {
  ko: [
    { type: 'pending', message: '클라이언트 xxx의 예약이 대기 중입니다.' },
    { type: 'confirmed', message: '클라이언트 abc의 예약이 확인되었습니다.' },
    { type: 'cancelled', message: '클라이언트 kk의 예약이 취소되었습니다.' },
  ],
  en: [
    { type: 'pending', message: 'Reservation pending for client xxx.' },
    { type: 'confirmed', message: 'Reservation confirmed for client abc.' },
    { type: 'cancelled', message: 'Reservation cancelled for client kk.' },
  ],
  fr: [
    { type: 'pending', message: 'Réservation en attente pour le client xxx.' },
    { type: 'confirmed', message: 'Réservation confirmée pour le client abc.' },
    { type: 'cancelled', message: 'Réservation annulée pour le client kk.' },
  ]
};

function ArtistReservationManagerPage() {
  const { userInfo } = useContext(UserContext);
  const lang = getUserLanguage(userInfo);
  const navigate = useNavigate();

  // PWA 노치 색상을 페이지 배경색(#f8f8f8)과 통일
  useEffect(() => {
    const themeColorMeta = document.querySelector('meta[name="theme-color"]');
    if (themeColorMeta) {
      themeColorMeta.setAttribute('content', '#fffdf8');
    }
  }, []);

  // 편의 함수 - 현재 미사용
  // eslint-disable-next-line no-unused-vars
  const handleMenuClick = (key) => {
    if (key === 'personal') {
      navigate('/personal-projects');
    }
  };

  return (
    <div className="artist-reservation-manager-wrapper" style={{ overflow: 'auto', height: '100%', background: '#fffdf8' }}>
      {/* 최상단 세로여백 10px */}
      <div style={{ height: 10 }} />
      {/* 통계 컴포넌트 */}
      <ArtistReservationManager
        lang={lang}
        notifications={NOTIFICATIONS[lang] || NOTIFICATIONS.en}
        userInfo={userInfo}
      />
      {/* 플로팅 메뉴 여백 */}
      <div style={{ height: 100 }} />
    </div>
  );
}

export default ArtistReservationManagerPage; 